import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
const updateTestStatus = createAsyncThunk(
  'appointments/updateTestStatus',
  async ({ appointmentId, testid, newStatus }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${baseUrl}/appointments/${appointmentId}/test/${testid}/status`,
        { status: newStatus }
      );

      return {
        appointmentId,
        testid,
        updatedFields: { status: newStatus },
        data: response.data,
      };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || 'Failed to update test status';
      return rejectWithValue(message);
    }
  }
);

export default updateTestStatus;
